import { Button, Card } from "@mui/material";
import { InsertDriveFile } from "@mui/icons-material";
import FileDropzone from "components/common/dropzone/Dropzone";
import React from "react";
import { useSelector } from "react-redux";
import useInOfficeFileUpload from "./useInOfficeFileUpload";

const InOfficeFileUpload = () => {
  const { isUploadingInOfficeFile } = useSelector(
    (state) => state.manualUpload
  );

  const { inOfficeFileName, cancelFile, handleFileUpload } =
    useInOfficeFileUpload({ handlePatientSelect: () => {} });

  return (
    <div
      style={{
        boxSizing: "border-box",
        width: "100%",
        position: "relative",
      }}
    >
      {!inOfficeFileName && (
        <Card style={{ padding: 10 }}>
          <FileDropzone
            onDrop={handleFileUpload}
            multiple={false}
            style={{ height: "300px" }}
            content={
              <span>
                <p>Drop your in-office note files here to upload</p>
                <p
                  style={{
                    fontSize: "smaller",
                    color: "#787272",
                  }}
                >
                  (DISCLAIMER: Only ".bnk", ".xml", ".log" and ".23X" files
                  allowed.)
                </p>
                <p>or</p>
              </span>
            }
          />
        </Card>
      )}

      {inOfficeFileName && (
        <Card className="uploadFileNameWrapper mb-3">
          <div className="d-flex justify-between">
            <h3>Selected Files</h3>
            <Button
              variant="outlined"
              color="secondary"
              onClick={cancelFile}
              disabled={isUploadingInOfficeFile}
            >
              Replace file
            </Button>
          </div>
          <p className="d-flex align-center mb-2">
            <InsertDriveFile style={{ color: "#949494" }} />
            <span className="ml-2" style={{ fontSize: "16px" }}>
              {inOfficeFileName}
            </span>
          </p>
        </Card>
      )}
    </div>
  );
};

export default InOfficeFileUpload;
